/* eslint-disable react-refresh/only-export-components */
import { lazy } from 'react'
import type { RouteObject } from 'react-router-dom'

const ExportPage = lazy(() => import('./pages/ExportPage'))

export const exportRoutes: RouteObject[] = [
  {
    path: 'export',
    element: <ExportPage />,
  },
]
